import {useEffect, useState} from 'react'
import {BooksitoutServer} from '../../../../config/BooksitoutServer'
import ReadingSpeedRankingResponse from '../responses/ReadingSpeedRankingResponse'

const useReadingSpeedRanking = () => {
	const [data, setData] = useState<ReadingSpeedRankingResponse | null>(null)
	const [isLoading, setIsLoading] = useState<boolean>(true)

	useEffect(() => {
		BooksitoutServer
			.get(`/v1/statistics/reading-speed-ranking`)
			.then(res => setData(res.data))
			.finally(() => setIsLoading(false))
	}, [])

	return [data, isLoading] as const
}

export default useReadingSpeedRanking
